"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _attendee = require("../../../actions/attendee");
function mixerAttendeeJoined(_ref, _ref2) {
  var dispatch = _ref.dispatch;
  var attendeeId = _ref2.attendeeId;
  dispatch((0, _attendee.setMixerAttendee)(attendeeId));
}
var _default = exports["default"] = mixerAttendeeJoined;